import React from 'react'
import {Redirect} from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import AgencyForm from './AgencyForm'
import AgencyCard from './AgencyCard'

import Resource from '../../stores/resource'
const AgencyStore = Resource('agencies')

class NewAgency extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      agency: (this.props.attributes || {}),
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null
    }
  }

  _save = (attributes) => {
    AgencyStore.create(attributes)
    .then((result) => {
      this.setState({
        saved: true,
        error: '',
        savedAgency: result.data.data,
        snackbarMessage: `Agency "${attributes.name}" created!`
      },
      () => {
        if (this.props.savedCallback) {
          this.props.savedCallback(this.state.savedAgency)
        }
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _closeErrorDialog = () => this.setState({error: ''})

  _closeSuccessDialog = () => this.setState({redirect: `/agencies`})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect}/>

    const agency = this.state.agency
    const saved = this.state.saved

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog}/>
    ]

    return (
      <section>
        <AgencyForm
          formTitle={this.props.formTitle}
          code={agency.code}
          name={agency.name}
          phone={agency.phone}
          address={agency.address}
          city={agency.city}
          province={agency.province}
          country={agency.country}
          postalCode={agency.postalCode}
          forceChanged={this.props.forceChanged}
          submitCallback={this._save}
          cancelCallback={this.props.cancelCallback}
        />
        <br/>

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create agency">
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved && this.props.showSuccessDialog &&
          <Dialog
            actions={successDialogActions}
            modal={false}
            onRequestClose={this._closeSuccessDialog}
            open={Boolean(this.state.saved)}
            title="Agency created">
            <p>
              A new agency has been created with the information below.<br/>
              If you see any incorrect information, press the <strong>Edit</strong> button.
            </p>
            <AgencyCard
              agency={this.state.savedAgency}
              editCallback={() => this._redirectTo(`/agencies/${this.state.savedAgency.id}/edit`)}
            />
          </Dialog>
        }
      </section>
    )
  }
}

export default NewAgency



// WEBPACK FOOTER //
// ./src/components/Agencies/NewAgency.jsx